export enum DaySessions {
  MORNING = 'morning',
  AFTERNOON = 'afternoon',
  EVENING = 'evening',
}
